import { WorldpayCustomisation } from './worldpay-customisation.interface';
import { WorldpayIntegrationType } from './worldpay-integration-type.enum';
import { WorldpayResult } from './worldpay-result.interface';

export interface WorldpayOptions {
  accessibility?: boolean;
  cancelURL?: string;
  country?: string;
  customisation?: WorldpayCustomisation;
  debug?: boolean;
  disableScrolling?: boolean;
  errorURL?: string;
  failureURL?: string;
  flowCallback?: () => unknown;
  iframeHelperURL: string;
  inject?: string;
  language?: string;
  pendingURL?: string;
  preferredPaymentMethod?: string;
  resultCallback?: (result: WorldpayResult) => unknown;
  successURL?: string;
  target: string;
  type: WorldpayIntegrationType;
  url: string;
}
